export enum WorkflowType {
  DRAFT = 'Draft',
  PUBLISHED = 'Published',
}

export enum WorkflowStatus {
  DRAFT = 'Draft',
  PUBLISHED = 'Published',
  DELETED = 'Deleted',
}
